import React, { useState } from "react";
import ModalRegenerate from "./ModalRegenerate";

const WrapModalRegenerate = ({ handleRemove, idRemove, children, ...props}) => {
  const [open, setOpen] = useState(false)

  const handleOpen = () =>  {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      {children({ onOpen: handleOpen })}
      {open && 
        <ModalRegenerate
          isOpen={open}
          toggle={handleClose}
          {...props}
        />
      }
    </>
  )
}

export default WrapModalRegenerate
